import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getFollowUpData(params) {
    return client.get("tunnel/api/pos/prospective_member/data", {
        params: params,
    });
}

function updateFollowUp(params) {
    return client.post("tunnel/api/pos/prospective_member/update_followup_status", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

export default {
    getFollowUpData,
    updateFollowUp
};